export enum SetPasswordBackendError {
  TokenUsed = 'token-used',
  PasswordRequired = 'password-required',
  PasswordMatchPasswordCheck = 'password-match-password-check',
  WeakPassword = 'weak-password',
  ShortPassword = 'too_small',
}

export const isSetPasswordBackendError = (value: unknown): value is SetPasswordBackendError =>
  typeof value === 'string' && Object.values(SetPasswordBackendError).some(item => item === value);

export const SET_PASSWORD_FORM_INITIAL_VALUES = {
  password: '',
  passwordCheck: '',
} as const;
